<div class="container-fluid">
  <core-spinner *ngIf="vm.isLoading"></core-spinner>
  <cli-landing-header></cli-landing-header>

  <div class="row">
    <div class="col-xl-2 col-lg-1 "></div>
    <div class="col-xl-2 col-lg-2 col-md-3  pt-4">
      <cli-landing-menu></cli-landing-menu>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-5 ">

      <div class="mt-2 mb-4 row">
        <div class="col welcome-text text-center">Forgot Hydrotrak Password?</div>
      </div>

      <div class="mt-2 mb-4 row">
        <div class="col d-flex justify-content-center">
          <div style="width:300px;">
            <form>


              <div *ngIf="!vm.isSubmitted">
                <div class="row">
                  <div class="col mb-2">
                    <input class="form-control" [ngClass]="{'is-invalid': !!error('userName')}" name="userName"
                      placeholder="Permit Number" type="text" [(ngModel)]="vm.userName">
                    <div class="invalid-feedback">
                      {{error('userName')}}
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col mb-2">

                    <input class="form-control" [ngClass]="{'is-invalid': !!error('email')}" name="email"
                      placeholder="Email" type="text" [(ngModel)]="vm.email">
                    <div class="invalid-feedback">
                      {{error('email')}}
                    </div>
                  </div>
                </div>              

                <div class="mt-4 mb-2 row">
                  <div class="col"></div>
                  <div class="col-md-6">
                    <button class="btn btn-block btn-primary" (click)="submit()">Submit</button>
                  </div>
                  <div class="col"></div>
                </div>
              </div>
            
            </form>
          </div>
        </div>
      </div>

      <div class="mt-4 mb-2 row">
          <div *ngIf="!vm.isSubmitted" class="col text-center">Please provide your permit number and email address and we will send you instructions on
            how to reset your password</div>
        </div>
      
        <div *ngIf="vm.isSubmitted" class="alert alert-info">
            We have sent you an email with the next steps to complete password reset
        </div>
    
    </div>
    <div class="col-xl-2 col-lg-2 col-md-3"></div>
    <div class="col-xl-2 col-lg-1 "></div>
  </div>

  <div style="padding-bottom:100px"></div>
  <cli-landing-footer></cli-landing-footer>
</div>